// The Comic Machine - Viewer UI

var VieweController = (function() {

  // Handles UI and DOM manipulation
  var UI = {

    // Reference to the current viewer instance
    viewer: null,

    // DOM elements to manage
    elements: {},

    // Flag for fullscreen mode
    fullscreenMode: false,

    // Placeholders for progress values
    progress: {
      current: 0,
      total: 0,
    },

    // Initialize the UI and DOM manager
    initialize: function() {

      // DOM elements to manage
      UI.elements.container = document.querySelector(".viewer");
      UI.elements.wrapper = document.querySelector(".viewer-wrapper");
      UI.elements.canvas = document.querySelector(".viewer canvas");
      UI.elements.header = document.querySelector(".header");

      UI.elements.navigation = {
        container: document.querySelector(".viewer-navigation"),
        pagination: document.querySelector(".viewer-pagination"),
        targets: document.querySelectorAll(".viewer-target"),
        prev: document.querySelector(".viewer-target[data-target='prev']"),
        main: document.querySelector(".viewer-target[data-target='main']"),
        next: document.querySelector(".viewer-target[data-target='next']"),
        proceed: document.querySelector(".viewer-next"),
      };

      UI.elements.buttons = {
        close: document.querySelector(".viewer .close"),
        fullscreen: document.querySelector(".viewer .button-fullscreen"),
      };

      // UI.elements.slider = {
      //   container: document.querySelector(".viewer-slider"),
      //   wheel: document.querySelector(".viewer-slider-wheel"),
      //   shadow: document.querySelector(".viewer-slider-shadow"),
      //   thumbmail: document.querySelector(".viewer-slider-thumbmail"),
      //   handle: document.querySelector(".viewer-slider-handle"),
      //   page: document.querySelector(".viewer-slider-page"),
      //   progress: document.querySelector(".viewer-progress"),
      // };

      // Create the viewer object
      UI.viewer = new Viewer({
        element: UI.elements.canvas,
      });

      // Bind handlers to events
      UI.bindEvents();

    },

    // Bind handlers to events
    bindEvents: function() {

      // Handle on click of close preview button
      attachHandler(UI.elements.buttons.close, UI.close);

      // Handle on click of fullscreen preview button
      attachHandler(UI.elements.buttons.fullscreen, UI.fullscreen);

      // Handle on click of canvas
      attachHandler(UI.elements.navigation.targets, UI.navigation.toggle);

      // Handle on move of the slider
      // document.body.addEventListener("mousedown", UI.mouse.down, false);
      // document.body.addEventListener("mousemove", UI.mouse.move, false);
      // document.body.addEventListener("mouseup", UI.mouse.up, false);

      // Handle resize
      window.addEventListener("resize", function(event) {
        if (window.innerWidth < 1024 && !UI.fullscreenMode) {
          UI.fullscreen();
        }
        if (UI.fullscreenMode) {
          UI.resizeFullscreen();
        }
      });

      // Handle on key press of Esc to close preview
      document.documentElement.addEventListener("keyup", function(event) {
        if (event.keyCode !== 27) {
          return;
        }
        UI.close();
      }, false);

    },

    // Method to open the viewer panel
    open: function(data) {

      UI.progress.pages = data.pages;
      UI.progress.pages = data.pages;
      UI.progress.total = data.pages.length;

      window.setTimeout(function() {
        UI.elements.navigation.container.dataset.active = "false";
      }, 5000);

      UI.elements.container.dataset.active = "true";
      UI.viewer.preview(data);

      // Create the pagination thumbs and functionality
      var fragment = document.createDocumentFragment();
      UI.elements.navigation.pagination.innerHTML = "";
      data.pages.forEach(function(page, index) {
        var li = document.createElement("li");
        var button = document.createElement("button");
        button.dataset.index = index || "";
        button.onclick = function() {
          UI.viewer.renderComic(index, true);
          for (var i = 0; i < UI.elements.navigation.items.length; i++) {
            var button = UI.elements.navigation.items[i];
            button.classList.toggle("active", index === i);
          }
          // UI.viewer.timeline.pause();
        };
        button.style.backgroundImage = 'url("' + page.thumbnail + '")';
        li.appendChild(button);
        fragment.appendChild(li);
      });
      UI.elements.navigation.pagination.appendChild(fragment);
      UI.elements.navigation.items = UI.elements.navigation.pagination.querySelectorAll('button');

      Events.global.on("pagination.update", function(args) {
        UI.setActivePage(args.index, args.fromNavigationClick);
      });

      // if (window.innerWidth < 1024 && !UI.fullscreenMode) {
      UI.fullscreen();

    },

    // Method to close the viewer panel
    close: function() {

      // If in fullscreen mode, exit that first
      if (UI.fullscreenMode && window.innerWidth >= 1024) {
        return UI.fullscreen();
      }

      UI.elements.container.setAttribute("data-active", false);
      UI.viewer && UI.viewer.reset();
      // UI.viewer = null;

      UI.navigation.active = false;
      UI.elements.navigation.container.setAttribute("data-active", "false");

      var url = window.location.hash.replace("#/", "").split("/")[0];

      if (LandingController.view === "published") { // HACK
        window.history.pushState({}, document.title, "/#/gallery/published");
      } else if (LandingController.view === "public") {
        window.history.pushState({}, document.title, "/#/" + url); // HACK
      }

      // TWEEN.removeAll();

    },

    // Method to set the active page in the pagination
    setActivePage: function(index, fromNavigationClick) {

      for (var i = 0; i < UI.elements.navigation.items.length; i++) {
        var button = UI.elements.navigation.items[i];
        button.classList.toggle("active", index === i);
      }

      if (!fromNavigationClick) {
        return;
      }

      window.setTimeout(function() {
        UI.elements.navigation.container.dataset.active = "false";
      }, 2000);

    },

    // Method to fullscreen the viewer panel
    fullscreen: function(force) {

      if (force) {
        if (UI.elements.container.className.indexOf("fullscreen") < 0) {
          UI.elements.container.className += " fullscreen";
        }
        UI.fullscreenMode = true;
        UI.resizeFullscreen();
        return;
      }

      if (!UI.viewer || !UI.elements.container) {
        return;
      }

      if (UI.elements.container.className.indexOf("fullscreen") > -1) {
        UI.elements.container.className = UI.elements.container.className.replace(" fullscreen", "");
        UI.fullscreenMode = false;
      } else {
        UI.elements.container.className += " fullscreen";
        UI.fullscreenMode = true;
      }

      UI.resizeFullscreen();

    },

    // Method to get the window size
    resizeFullscreen: function() {

      var size = UI.getWindowSize();
      var orientation = size.orientation;
      var offset = 0;

      if (UI.fullscreenMode) {

        if (orientation === "landscape") {
          offset = size.height * (4 / 3); // 1024 * (3/4) = 768
          if (offset > size.width) {
            orientation = "portrait";
            offset = size.width * (3 / 4);
          }
        } else {
          offset = size.width * (3 / 4); // 768 * (4/3) = 1024
          if (offset > size.height) {
            orientation = "landscape";
            offset = size.height * (4 / 3);
          }
        }

        // HACK
        if (orientation === "landscape") {
          UI.elements.wrapper.style.width = offset + "px";
          UI.elements.wrapper.style.height = 100 + "%";
          UI.elements.wrapper.style.top = 0;
          UI.elements.wrapper.style.left = ((size.width - offset) / 2) + "px";
        } else {
          UI.elements.wrapper.style.width = 100 + "%";
          UI.elements.wrapper.style.height = offset + "px";
          UI.elements.wrapper.style.top = ((size.height - offset) / 2) + "px";
          UI.elements.wrapper.style.left = 0;
        }

        UI.elements.wrapper.style.margin = "0";

        UI.elements.header.style.display = "none";

      } else {

        // HACK
        UI.elements.wrapper.style.width = "1024px";
        UI.elements.wrapper.style.height = "768px";
        UI.elements.wrapper.style.top = "50%";
        UI.elements.wrapper.style.left = "50%";
        UI.elements.wrapper.style.margin = "-394px 0 0 -522px";

        UI.elements.header.style.display = "block";

      }

    },

    // Method to get the window size
    getWindowSize: function() {

      var size = {
        width: window.innerWidth,
        height: window.innerHeight,
      };

      if (size.width >= size.height) {
        size.orientation = "landscape";
      } else {
        size.orientation = "portrait";
      }

      return size;

    },

    // Method to progress the comic
    proceed: function() {

      if (!UI.viewer) {
        return;
      }

      // If there is a wait that can be continued
      if (UI.viewer.waitForClick !== false && UI.viewer.waitList.length > 0) {
        // console.log("viewer", "onClick", "clicking", UI.viewer.waitList);
        for (var key in UI.viewer.list) {
          var layer = UI.viewer.list[key];
          var hasRemove = layer.removeAfter && layer.removeAfter.duration > 0;
          if (layer.removeAfter && layer.removeAfter.duration < 0) {
            continue;
          }
          if (layer.type === 3 || (layer.type === 2 && hasRemove)) { // HACK
            if (hasRemove && layer.removeAfter.duration > 1) {
              layer.removeAfter.duration -= 1;
              continue;
            }
            UI.viewer.container.removeChild(layer.element);
            delete UI.viewer.list[key];
          }
        }
        UI.viewer.renderPage({
          layers: UI.viewer.waitList
        });
        // If at the end of the comic
      } else if (UI.viewer.pageCount >= UI.viewer.pageLength) {
        if (UI.viewer.comic.autoLoop) {
          UI.viewer.renderComic(0);
        } else {
          // console.log("viewer", "onClick", "closing");
          UI.close();
        }
        // Else proceed forward
      } else {
        if (UI.viewer.timeline.isActive()) {
          // console.log("viewer", "onClick", "stillRendering");
          // UI.viewer.pageCount += 1;
          // UI.viewer.renderPage();
        } else {
          // console.log("viewer", "onClick", "renderNextPage");
          UI.viewer.renderPage();
        }
      }

    },

    // Handles navigation related functionality
    navigation: {

      active: false,

      toggle: function(event) {

        event.preventDefault();

        var target = event.target.getAttribute("data-target");
        var active = UI.navigation.active;

        if (target === "main" || target === "nav" || active) {
          UI.navigation.active = !active;
          UI.elements.navigation.container.setAttribute("data-active", !active);
        } else if (target === "next" && !active) {
          UI.elements.navigation.proceed.setAttribute("data-active", "false");
          UI.proceed();
        }

      },

    },

  };

  window.addEventListener("load", UI.initialize, false);

  // Public / exposed object
  return UI;

})();
